var _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFilterTopicAll(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 15,
    viewBox: "0 0 15 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.04785 3.44584V1.92563C4.04785 1.41442 4.46558 1 4.98087 1H13.067C13.5823 1 14 1.41442 14 1.92563V9.94778C14 10.459 13.5823 10.8734 13.067 10.8734H11.5174",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M10.0191 4.12646H1.93301C1.41773 4.12646 1 4.54089 1 5.0521V13.0742C1 13.5855 1.41773 13.9999 1.93301 13.9999H10.0191C10.5344 13.9999 10.9522 13.5855 10.9522 13.0742V5.0521C10.9522 4.54089 10.5344 4.12646 10.0191 4.12646Z",
    stroke: "currentColor",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M3.16094 8.94883L4.94465 10.5542C5.0017 10.6055 5.08829 10.6055 5.14534 10.5542L8.81311 7.25317",
    stroke: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFilterTopicAll);
export default __webpack_public_path__ + "static/media/filter-topic-all.905d830f7bf7ee99484d41fc70013214.svg";
export { ForwardRef as ReactComponent };